const advancedFilter = () => {
    const params = new URLSearchParams(window.location.search);

    document.querySelectorAll('input[type="text"][name], input:not([type])[name]').forEach((input) => {
        const paramName = input.name;
        if (params.has(paramName)) {
            input.value = params.get(paramName);
        }
    });

    document.querySelectorAll('select[name]').forEach((select) => {
        const paramName = select.name;
        if (params.has(paramName)) {
            select.value = params.get(paramName);
        }
    });

    document.querySelectorAll('input[type="checkbox"][name*="[]"]').forEach((checkbox) => {
        const paramName = checkbox.name;
        if (params.getAll(paramName).includes(checkbox.value)) {
            checkbox.checked = true;
        }
    });

    document.querySelectorAll('input[type="checkbox"][name]:not([name*="[]"])').forEach((checkbox) => {
        const paramName = checkbox.name;
        if (params.has(paramName) && params.get(paramName) === checkbox.value) {
            checkbox.checked = true;
        }
    });

    const chosenValues = [];

    document.querySelectorAll('input[type="text"][name], input:not([type])[name]').forEach((input) => {
        if (input.value.trim() !== '') {
            chosenValues.push(input.value.trim());
        }
    });

    document.querySelectorAll('select[name]').forEach((select) => {
        if (select.value.trim() !== '') {
            chosenValues.push(select.options[select.selectedIndex].text.trim());
        }
    });

    document.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
        const label = document.querySelector(`label[for="${checkbox.id}"]`);
        if (label) {
            chosenValues.push(label.textContent.trim());
        } else {
            chosenValues.push(checkbox.value);
        }
    });

    const searchedTermDiv = document.querySelector('.js-searched-term');
    if (searchedTermDiv) {
        searchedTermDiv.innerHTML = '';

        if (chosenValues.length > 0) {
            const p = document.createElement('p');
            p.textContent = `Showing "${chosenValues.join(', ')}"`;
            searchedTermDiv.appendChild(p);
        }
    }

    const advancedFilterBlockContainer = document.querySelector('.fndry-advanced-filters--programs');

    if (advancedFilterBlockContainer) {
        const advancedFilterBlock = advancedFilterBlockContainer.querySelector('.fndry-advanced-filters');

        if (advancedFilterBlock) {
            // 1. Move "Reset Filters" button to the top after the first child

            const overlay = advancedFilterBlock.querySelector('.fndry-advanced-filters__overlay-container');

            const resetBtn = overlay.querySelector('.fndry-advanced-filters__btn-reset');

            const fieldset = overlay.querySelector('.fndry-advanced-filters__fieldset');

            if (resetBtn && fieldset) {
                overlay.insertBefore(resetBtn, fieldset);
            }

            // 2. Duplicate "Clear Filters" button and make a new "All Courses" button in the overlay

            const clearBtn = advancedFilterBlockContainer.querySelector('.clear-filters');

            if (clearBtn) {
                const newBtn = clearBtn.cloneNode(true);

                overlay.appendChild(newBtn);

                newBtn.classList.remove('fndry-btn-filterButtonClearFiltersBlack');

                newBtn.classList.add('fndry-btn-filterButtonGoBack');

                newBtn.textContent = "All Courses";

                // 2.1 create arrow icon

                const newBtnIconNS = 'http://www.w3.org/2000/svg';

                const newBtnIconEl = document.createElementNS(newBtnIconNS, 'svg');
                const attrs = {
                    class: 'svg-inline--fa',
                    'aria-hidden': 'true',
                    focusable: 'false',
                    'data-prefix': 'far',
                    'data-icon': 'rotate-right',
                    role: 'img',
                    xmlns: 'http://www.w3.org/2000/svg',
                    viewBox: '0 0 512 512',
                    'data-fa-i2svg': ''
                };

                for (const [key, value] of Object.entries(attrs)) {
                    newBtnIconEl.setAttribute(key, value);
                }

                // Optional: add a comment (note comments can’t be added directly this way in DOM, usually skipped)

                // Create the <path>
                const newBtnIconPathEl = document.createElementNS(newBtnIconNS, 'path');
                newBtnIconPathEl.setAttribute('d', 'M17 239L0 256l17 17L153 409l17 17L203.9 392l-17-17-95-95L488 280l24 0 0-48-24 0L91.9 232l95-95 17-17L169.9 86.1l-17 17L17 239z');

                // Append path to svg
                newBtnIconEl.appendChild(newBtnIconPathEl);

                newBtnIconEl.classList.add('svg-inline--fa');

                newBtn.insertBefore(newBtnIconEl, newBtn.firstChild);

                overlay.insertBefore(newBtn, resetBtn);

            }

            // 3. Insert current program type title above the "All Courses" button
            const goBackBtn = overlay.querySelector('.fndry-advanced-filters__btn-reset');

            if (goBackBtn) {
                const pathSegments = window.location.pathname.split('/').filter(Boolean);
                const lastSegment = pathSegments[pathSegments.length - 1];
                const fullPath = `/${pathSegments.join('/')}/`;

                const h4 = document.createElement('h4');
                h4.classList.add('fndry-program-type-title');

                if (fullPath === '/program-duration/under-6-months/') {
                    h4.textContent = 'Programs Under 6 Months';
                    overlay.insertBefore(h4, goBackBtn);
                } else if (fullPath === '/all-programs/') {
                    h4.textContent = 'All Programs';
                    overlay.insertBefore(h4, goBackBtn);
                } else {
                    // Fallback: try to fetch from program-type taxonomy
                    fetch(`/wp-json/wp/v2/program-type?slug=${lastSegment}`)
                        .then(response => response.json())
                        .then(data => {
                            if (Array.isArray(data) && data.length > 0) {
                                h4.textContent = data[0].name;
                                overlay.insertBefore(h4, goBackBtn);
                            }
                        })
                        .catch(error => {
                            console.error('Failed to fetch program type:', error);
                        });
                }
            }

        }
    }


};

export default advancedFilter;
